<template>
  <div>
    <page-header title="Instituições">
      <template #description>
        Catálogo de todas as instituições cadastradas (universidades,
        faculdades, escolas). Busque pelo nome da IES e abra a ficha pra
        configurar regras de negócio, recebedores, contratos digitais,
        regras de acordo e rematrícula.
      </template>
      <template #actions>
        <institution-import />
      </template>
    </page-header>

    <div class="panel panel-default">
      <div class="panel-body">
        <div class="row">
          <div class="col-md-6">
            <div class="dashboard-panel__search-fields">
              <input type="search"
                     class="form-control dashboard-panel__search-input"
                     placeholder="Pesquisar por nome da IES"
                     v-model="institutionSearch"
                     @keyup.enter="searchInstitutions()"
              >
              <button class="btn btn-default" type="button" @click="searchInstitutions()">
                Buscar
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="table-responsive" v-if="institutions.length > 0">
        <table class="table table-hover table-spaced table--no-margin-bottom">
          <thead>
            <tr>
              <th>ID</th>
              <th>Nome da instituição</th>
              <th>Grupo Educacional</th>
              <th>Tipo de instituição</th>
              <th>Rematrícula habilitada?</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="institution in institutions" :key="institution.id">
              <td>
                <div class="dashboard-panel__table-item" data-toggle="tooltip"
                     :data-original-title="institution.id"
                >
                  {{ institution.id }} # QB: {{ institution.qb_university_id }}
                </div>
              </td>
              <td>
                <div class="dashboard-panel__table-item" data-toggle="tooltip"
                     :data-original-title="institution.name"
                >
                  <router-link :to="{ name: 'business-rule-group', params: { id: institution.id } }">
                    {{ institution.name }}
                  </router-link>
                </div>
              </td>
              <td>
                <div class="dashboard-panel__table-item" data-toggle="tooltip"
                     :data-original-title="institution.group_name"
                >
                  {{ institution.group_name }}
                </div>
              </td>
              <td>
                <div class="dashboard-panel__table-item" data-toggle="tooltip"
                     :data-original-title="institution.translated_kind"
                >
                  {{ institution.translated_kind }}
                </div>
              </td>
              <td>
                <div class="dashboard-panel__table-item" data-toggle="tooltip"
                     :data-original-title="translateInstitutionReenrollment(institution.reenrollment_enabled)"
                >
                  {{ translateInstitutionReenrollment(institution.reenrollment_enabled) }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="panel-footer" v-if="totalPages">
          <pagination ref="pagination" :total-pages="totalPages" @page-changed="onPageChange" />
        </div>
      </div>

      <div class="panel-body" v-else>
        <div class="dashboard-panel__not-found-message text-center">
          Nenhuma instituição encontrada.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InstitutionsService from 'services/InstitutionsService';
import Pagination from 'components/Pagination';
import InstitutionImport from 'components/InstitutionImport';

export default {
  data() {
    return {
      institutions: [],
      institutionSearch: '',
      totalPages: 0,
      currentPage: 1,
    };
  },
  components: {
    Pagination,
    InstitutionImport,
  },
  mounted() {
    this.loadInstitutions();
    this.initializeTooltips();
  },
  methods: {
    searchInstitutions() {
      this.currentPage = 1;
      this.totalPages = null;
      this.loadInstitutions();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.loadInstitutions();
    },
    translateInstitutionReenrollment(reenrollment) {
      if (reenrollment) {
        return 'Sim';
      }
      return 'Não';
    },
    initializeTooltips() {
      $(() => {
        $('[data-toggle="tooltip"]').tooltip();
      });
    },
    loadInstitutions() {
      this.$loader.show();
      InstitutionsService.getInstitutions(this.institutionSearch, this.currentPage)
        .then(({ data }) => {
          this.institutions = data.institutions;
          this.totalPages = data.total_pages;
          this.initializeTooltips();
          this.$loader.hide();
        })
        .catch((error) => {
          this.$loader.hide();
          this.institutions = [];
          this.$alert.notifyAlert(error.response.data.message);
        });
    },
  },
};
</script>
